<template>
  <RevDrawer
    :name="MODAL_NAMES.GIFT_CARDS_FAQ"
    size="small"
    :title="i18n(translations.title)"
  >
    <template #body>
      <div class="flex flex-col gap-24">
        <div>
          <div class="body-2-bold">{{ i18n(translations.question1) }}</div>
          <div class="text-static-default-low body-2">
            {{ i18n(translations.answer1) }}
          </div>
        </div>
        <div>
          <div class="body-2-bold">{{ i18n(translations.question2) }}</div>
          <div class="text-static-default-low body-2">
            {{ i18n(translations.answer2) }}
          </div>
        </div>
        <div>
          <div class="body-2-bold">{{ i18n(translations.question3) }}</div>
          <div class="text-static-default-low body-2">
            {{ i18n(translations.answer3) }}
          </div>
        </div>
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import { MODAL_NAMES } from '~/scopes/gift-cards/constant'

import translations from './FaqDrawer.translations'

const i18n = useI18n()
</script>
